import isSMIMEItem from './isSMIMEItem';
import { confirm } from 'owa-confirm-dialog';
import { ClientItem, mailStore } from 'owa-mail-store';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';

/**
 * Response is blocked for S/MIME in conversation view.
 * @param itemId itemId of the itemPart in conversation for which we are responding.
 * @param itemActionString actionString eg. Reply/Forward/Reply All
 */
export const allowResponseForSmimeConversation = (
    itemId: string,
    itemActionString: string
): boolean => {
    const item: ClientItem = mailStore.items.get(itemId);

    if (!isSMIMEItem(item)) {
        // If the item is non-S/MIME allow response
        return true;
    }

    // TODO: strings needs to be changed, since S/MIME reply/replyAll/forward not allowed in conversation view
    const messageString = format(strings.irm_actionNotAllowedOnThisConversation, itemActionString);
    confirm(null /* title */, messageString, false /* resolveImmediately */, {
        hideCancelButton: true,
    });

    return false;
};

export default allowResponseForSmimeConversation;
